export const MAX_NUMBER_OF_LISTINGS = 10;
export const RATING_RANGE = {
  best: 5,
  worst: 1,
};
